import { useMemo } from 'react';
import { Row, Col, SelectField } from '@gv/triage-components';

import { complaintsOptionsFactory } from 'utils/helpers';
import { useListQuery } from 'store/api/chief-complaints';

export const Complaints = () => {
  const { data: chiefComplaints, isFetching: isLoadingComplaints } =
    useListQuery();

  const complaintsOptions = useMemo(complaintsOptionsFactory(chiefComplaints), [
    chiefComplaints,
  ]);

  return (
    <Row>
      <Col>
        <SelectField
          isMulti
          onlyValue
          isClearable
          isAutocomplete
          name="chief_complaints"
          label="Chief complaint"
          requiredText="(Required)"
          placeholder="Start typing"
          options={complaintsOptions}
          isDisabled={isLoadingComplaints}
        />
      </Col>
    </Row>
  );
};
